import React, { Component } from 'react'
import { connect } from 'react-redux'
import { TokenActions, UserActions, SnackbarActions } from 'actionsets'
import StyleSheet, { AppStyles } from 'styles'
import { Link } from 'react-router-dom'
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import { CenteredCard } from 'components'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import {eventKeyMatches, KEYS} from 'utils'
import {FormContext} from 'components'
import {Enable2faOtp} from 'components/user/Enable2fa'

export class Enable2fa extends Component{

  constructor(props){
    super(props)
    TokenActions.bindActions(this)
    UserActions.bindActions(this, 'user')
    SnackbarActions.bindActions(this, 'snackbar')
    this.state = {
      context: {otpRequiredForLogin: true}
    }
  }

  componentDidMount = async() => {
    if (this.props.currentUser.otpRequiredForLogin) {
      this.props.history.push('/')
    }
    else {
      const {data: {secret}} = await this.actions.user.generate2faSecret({id: this.props.currentUser.id})
      this.setState({secret})
    }
  }

  enable2fa = async() => {
    try{
      await this.actions.user.update({...this.state.context, id: this.props.currentUser.id})
      await this.actions.verify()
      this.props.history.push('/')
      this.actions.snackbar.success('2FA Enabled')
    }catch(err){
      this.actions.snackbar.error('2FA Setup Failed')
    }
  }

  get errors() {
    return (this.props.errors.update || {}).meta
  }

  render = () =>
    <CenteredCard className={styles.card}>
      <CardContent className={styles.content} onKeyUp={(e) => eventKeyMatches(e, KEYS.enter) && this.enable2fa()}>
        <Typography variant='h6' paragraph>Enable Two Factor Authentication (2FA)</Typography>
        <FormContext context={this.state.context} onChange={context => this.setState({context})}
                     errorContext={this.errors}>
          <Enable2faOtp member="otpAttempt" secret={this.state.secret} user={this.props.currentUser}/>
        </FormContext>
      </CardContent>
      <CardActions className={styles.actions}>
        <Button fullWidth variant='contained' color="primary" onClick={this.enable2fa}>Enable</Button>
        <Link className={[AppStyles.link, styles.navBeneath].join(' ')} to='/'>Cancel</Link>
      </CardActions>
    </CenteredCard>
}

const styles = StyleSheet({
  card: {
    padding: 15,
    paddingBottom: 50,
    maxWidth: 450,
  },
  actions: {
    flexWrap: 'wrap',
    paddingLeft: 16,
    paddingRight: 16,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  navBeneath: {
    color: '#b9b39b',
    fontSize: 14,
    marginTop: 15,
    textAlign: 'center',
    width: '100%'
  },
  googlePlay: {},
  apple: {}
})

export default connect(({tokens, users}) => ({...tokens, ...users}))(Enable2fa)